// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"J2-z"};